import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth.service';
import { HttpClient } from '@angular/common/http';
import { SearchService } from '../search.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

  public userid: string;
  public password: string;
  public loginMessage: string;

  constructor(
    public router: Router, 
    public route: ActivatedRoute,
    public httpClient: HttpClient,
    public authService: AuthService,
    public searchSvc: SearchService
  ) { }

  ngOnInit() {
  }

  keydown(e) {
    if (e.keyCode === 13)
    {
      this.login();
    }
  }

  login() {
    this.authService.login(this.userid, this.password).subscribe(
      (resp: any) => {
        if (resp.LoginSuccessful) {
          this.authService.storeUser(resp.User);
          this.router.navigate(["/search"], {relativeTo: this.route, skipLocationChange: true});
        }
        else {
          this.loginMessage = resp.Message;
        }  
      });
  }
}
